// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3DWvL","title":"Info_title__17h0g","selects":"Info_selects__1HV1t","requiredAsterisk":"Info_requiredAsterisk__1jjHD"};